<div class="candidate-duplications-wrap">
  <div class="duplications-info">
    <h4>
      {{ 'app.candidate.similar_profiles' | translate: { count: duplicates.length } }}
    </h4>
    <div class="profiles-links-wrap">
      @for (duplication of duplicates; track trackByDuplication(i, duplication); let i = $index) {
        @if (i <= duplicatesLimit - 1) {
          <div
            [ngClass]="{ active: duplication === id }"
            class="profile-link"
            (click)="moveToCandidate(duplication)"
          >
            @if (duplicates.length <= 3) {
              {{ 'app.candidate.profile' | translate }} #{{ i + 1 }}
            }
            @if (duplicates.length > 3) {
              #{{ i + 1 }}
            }
          </div>
        }
      }
      @if (duplicates.length > duplicatesLimit) {
        <div class="profile-link disabled">+ {{ duplicates.length - duplicatesLimit }}</div>
      }
    </div>
  </div>
  <div class="merge-action">
    <rt-button [loading]="loading" (click)="mergeClick()" variant="tertiary">
      <rt-icon name="magic-wand"></rt-icon>
      {{ 'app.candidate.merge_profiles' | translate: { count: duplicates.length } }}
    </rt-button>
  </div>
</div>
